import axios from "axios";


export const http2028 = axios.create({
    baseURL: process.env.REACT_APP_BOT_CLEAR_HTTPS,
});